/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publishevent1Inputs */

const en_publishevent1 = /** @type {(inputs: Publishevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Event`)
};

const de_publishevent1 = /** @type {(inputs: Publishevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish Event" |
*
* @param {Publishevent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const publishevent1 = /** @type {((inputs?: Publishevent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishevent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publishevent1(inputs)
	return de_publishevent1(inputs)
});
export { publishevent1 as "publishEvent" }